import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  OnField23al9ljlbymf9 as OnField,
  IfNotNull13ixxkuz43ozs as IfNotNull,
} from '../lightningdb/Condition.mjs';
import {
  OnFieldsnrykjjrmtcs as OnField_0,
  IfNotNull2i0zh8hr8em4r as IfNotNull_0,
} from '../lightningdb/Modification.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { nullElementzitp7se36veh as nullElement } from './SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClassPathAccessClass;
function DataClassPathAccess() {
  if (DataClassPathAccessClass === VOID) {
    class $ extends DataClassPath() {
      constructor(first, second) {
        super();
        this.i4q_1 = first;
        this.j4q_1 = second;
      }
      p3(key) {
        var tmp0_safe_receiver = this.i4q_1.p3(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0;
          try {
            tmp_0 = this.j4q_1.k2j(tmp0_safe_receiver);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Exception()) {
              var e = $p;
              printStackTrace(e);
              throw IllegalArgumentException().zd('Could not get ' + this.j4q_1.i20() + ' on ' + toString(tmp0_safe_receiver), e);
            } else {
              throw $p;
            }
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      k4q(key, value) {
        var tmp0_safe_receiver = this.i4q_1.p3(key);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.i4q_1.k4q(key, this.j4q_1.n2j(tmp0_safe_receiver, value));
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
      }
      toString() {
        var tmp;
        var tmp_0 = this.i4q_1;
        if (tmp_0 instanceof DataClassPathSelf()) {
          tmp = this.j4q_1.i20();
        } else {
          tmp = this.i4q_1.toString() + '.' + this.j4q_1.i20();
        }
        return tmp;
      }
      l4q() {
        return plus(this.i4q_1.l4q(), listOf(this.j4q_1));
      }
      k3t(condition) {
        return this.i4q_1.k3t(OnField().f3t(this.j4q_1, condition));
      }
      d44(modification) {
        return this.i4q_1.d44(OnField_0().a44(this.j4q_1, modification));
      }
      h2j() {
        return this.j4q_1.h2j();
      }
      hashCode() {
        var result = this.i4q_1.hashCode();
        result = imul(result, 31) + hashCode(this.j4q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DataClassPathAccess()))
          return false;
        if (!this.i4q_1.equals(other.i4q_1))
          return false;
        if (!equals(this.j4q_1, other.j4q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DataClassPathAccess');
    DataClassPathAccessClass = $;
  }
  return DataClassPathAccessClass;
}
var DataClassPathSelfClass;
function DataClassPathSelf() {
  if (DataClassPathSelfClass === VOID) {
    class $ extends DataClassPath() {
      constructor(serializer) {
        super();
        this.m4q_1 = serializer;
      }
      h2j() {
        return this.m4q_1;
      }
      p3(key) {
        return key;
      }
      n4q(key, value) {
        return value;
      }
      k4q(key, value) {
        var tmp = (key == null ? true : !(key == null)) ? key : THROW_CCE();
        return this.n4q(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      toString() {
        return 'this';
      }
      hashCode() {
        return 0;
      }
      equals(other) {
        return other instanceof DataClassPathSelf();
      }
      l4q() {
        // Inline function 'kotlin.collections.listOf' call
        return emptyList();
      }
      o4q(condition) {
        return condition;
      }
      k3t(condition) {
        return this.o4q(condition);
      }
      p4q(modification) {
        return modification;
      }
      d44(modification) {
        return this.p4q(modification);
      }
    }
    initMetadataForClass($, 'DataClassPathSelf');
    DataClassPathSelfClass = $;
  }
  return DataClassPathSelfClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      l3k(typeSerial0) {
        return new (DataClassPathSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.l3k(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DataClassPathPartialClass;
function DataClassPathPartial() {
  if (DataClassPathPartialClass === VOID) {
    class $ {}
    initMetadataForClass($, 'DataClassPathPartial', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    DataClassPathPartialClass = $;
  }
  return DataClassPathPartialClass;
}
var DataClassPathClass;
function DataClassPath() {
  if (DataClassPathClass === VOID) {
    class $ extends DataClassPathPartial() {
      q4a(key) {
        return this.p3(key);
      }
      prop(prop) {
        return new (DataClassPathAccess())(this, prop);
      }
      r4a() {
        return this.h2j();
      }
    }
    initMetadataForClass($, 'DataClassPath');
    DataClassPathClass = $;
  }
  return DataClassPathClass;
}
var DataClassPathNotNullClass;
function DataClassPathNotNull() {
  if (DataClassPathNotNullClass === VOID) {
    class $ extends DataClassPath() {
      constructor(wraps) {
        super();
        this.q4q_1 = wraps;
      }
      l4q() {
        return this.q4q_1.l4q();
      }
      p3(key) {
        return this.q4q_1.p3(key);
      }
      k4q(key, value) {
        return this.q4q_1.k4q(key, value);
      }
      toString() {
        return this.q4q_1.toString() + '?';
      }
      k3t(condition) {
        return this.q4q_1.k3t(IfNotNull().i3t(condition));
      }
      d44(modification) {
        return this.q4q_1.d44(IfNotNull_0().j42(modification));
      }
      h2j() {
        var tmp = ensureNotNull(nullElement(this.q4q_1.h2j()));
        return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
      }
      hashCode() {
        return this.q4q_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DataClassPathNotNull()))
          return false;
        if (!this.q4q_1.equals(other.q4q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DataClassPathNotNull');
    DataClassPathNotNullClass = $;
  }
  return DataClassPathNotNullClass;
}
function get_notNull(_this__u8e3s4) {
  return new (DataClassPathNotNull())(_this__u8e3s4);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  DataClassPathAccess as DataClassPathAccess21fi12r1lk4vq,
  DataClassPathNotNull as DataClassPathNotNullyxwowc5mmyv5,
  DataClassPathPartial as DataClassPathPartial2s3bzp98w5uo7,
  DataClassPathSelf as DataClassPathSelf9694s3fei65z,
  DataClassPath as DataClassPath3joljqmfaqhxf,
  get_notNull as get_notNull2xk5v9at1ay9v,
  Companion_instance as Companion_instance1kjus4hvx4qjx,
};
//endregion

//# sourceMappingURL=DataClassPath.mjs.map
